import { AxiosInstance } from 'axios';

import { SSOAPIApiFactory } from '@cast/openapi';
import { SSOAPIApiFactory as SSOSyncAPIApiFactory } from '@cast/openapi-organization-management';

import { AXIOS_CONFIGURATION } from '../constants';

export const SSOApiAdapter = (client: AxiosInstance) => {
  const generatedApi = SSOAPIApiFactory(AXIOS_CONFIGURATION, '', client);
  const syncApi = SSOSyncAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  return {
    createSSOConnection: generatedApi.sSOAPICreateSSOConnection,
    deleteSSOConnection: generatedApi.sSOAPIDeleteSSOConnection,
    getSSOConnection: generatedApi.sSOAPIGetSSOConnection,
    setSync: generatedApi.sSOAPISetSyncForSSOConnection,
    listSSOConnections: generatedApi.sSOAPIListSSOConnections,
    updateSSOConnection: generatedApi.sSOAPIUpdateSSOConnection,
    createSSOSyncConfig: syncApi.sSOAPICreateSSOSyncConfig,
    getSSOSyncConfig: syncApi.sSOAPIGetSSOSyncConfig,
    updateSSOSyncConfig: syncApi.sSOAPIUpdateSSOSyncConfig,
    deleteSSOSyncConfig: syncApi.sSOAPIDeleteSSOSyncConfig,
  };
};
